import LinkTitleComponent from '72cms-ui/components/table-elements/LinkTitleComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {
        name: {
            component: LinkTitleComponent,
        },
    },
    filterable: [],
    toolbar: ['create'],
    pagination: true,
    searchable: false,
    hierarchy: false,
    batchActions: [
        'active', 'delete',
    ],
    actions: [
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'delete',
            primary: true,
            component: 'delete-button',
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.news_categories.js